/* eslint-disable radix */
if (!customElements.get("filter-range")) {
  class FilterPriceRangeElement extends HTMLElement {
    // Called when the element is added to the DOM
    connectedCallback() {
      this.initRange();
    }

    // Called when the element is removed from the DOM
    disconnectedCallback() {
      // Clean up event listeners to prevent memory leaks
      const leftInput = this.querySelector(".range-slider__input-left");
      const rightInput = this.querySelector(".range-slider__input-right");

      if (leftInput) {
        leftInput.removeEventListener("input", this.leftInputHandler);
      }

      if (rightInput) {
        rightInput.removeEventListener("input", this.rightInputHandler);
      }
    }

    initRange() {
      const rangeSliderMin = 0;
      const rangeSliderMax = 100;

      // Set initial values and styles
      this.querySelector(".range-slider__val-left").style.width = `${rangeSliderMin + (100 - rangeSliderMax)}%`;
      this.querySelector(".range-slider__val-right").style.width = `${rangeSliderMin + (100 - rangeSliderMax)}%`;

      this.querySelector(".range-slider__val-range").style.left = `${rangeSliderMin}%`;
      this.querySelector(".range-slider__val-range").style.right = `${100 - rangeSliderMax}%`;

      this.querySelector(".range-slider__handle-left").style.left = `${rangeSliderMin}%`;
      this.querySelector(".range-slider__handle-right").style.left = `${rangeSliderMax}%`;

      // Set the input values
      const leftInput = this.querySelector(".range-slider__input-left");
      leftInput.value = rangeSliderMin;
      // Define the left input handler
      this.leftInputHandler = (e) => {
        e.target.value = Math.min(
          e.target.value,
          e.target.parentNode.querySelector(".range-slider__input-right").value - 1,
        );

        const value =
          (100 / (parseInt(e.target.max) - parseInt(e.target.min))) * parseInt(e.target.value) -
          (100 / (parseInt(e.target.max) - parseInt(e.target.min))) * parseInt(e.target.min);

        this.querySelector(".range-slider__val-left").style.width = `${value}%`;
        this.querySelector(".range-slider__val-range").style.left = `${value}%`;
        this.querySelector(".range-slider__handle-left").style.left = `${value}%`;
      };

      // Attach the left input event listener
      leftInput.addEventListener("input", this.leftInputHandler);

      // Set the right input value
      const rightInput = this.querySelector(".range-slider__input-right");
      rightInput.value = rangeSliderMax;

      // Define the right input handler
      this.rightInputHandler = (e) => {
        e.target.value = Math.max(
          e.target.value,
          e.target.parentNode.querySelector(".range-slider__input-left").value - -1,
        );

        const value =
          (100 / (parseInt(e.target.max) - parseInt(e.target.min))) * parseInt(e.target.value) -
          (100 / (parseInt(e.target.max) - parseInt(e.target.min))) * parseInt(e.target.min);

        this.querySelector(".range-slider__val-right").style.width = `${100 - value}%`;
        this.querySelector(".range-slider__val-range").style.right = `${100 - value}%`;
        this.querySelector(".range-slider__handle-right").style.left = `${value}%`;
      };

      // Attach the right input event listener
      rightInput.addEventListener("input", this.rightInputHandler);
    }
  }

  customElements.define("filter-range", FilterPriceRangeElement);
}
